var map = {
	"./blue-flag.png": "R0nh",
	"./bonifico1.png": "cPVT",
	"./bonifico2.png": "9HUF",
	"./comuni-ciclabili.png": "gxrZ",
	"./cover-prices.jpg": "bJTT",
	"./map_deu.png": "RCij",
	"./map_eng.png": "n04X",
	"./map_fra.png": "W48a",
	"./map_ita.png": "8PM1",
	"./piantinaA.png": "wWr8",
	"./piantinaB.png": "EwvK",
	"./programma.png": "JulU",
	"./programma_eng.png": "oVbm",
	"./vivi-Martinsicuro.svg": "cAHn"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "M9uD";